module.exports = __webpack_public_path__ + "static/media/airtable.c6de5e10.png";